import { use } from "i18next";
import StaffListDownloadIcon from "../../assets/images/StaffListDownloadIcon";
import { DashboardConstants } from "../../constants/constants";
import { useTranslation } from "react-i18next";

const DownloadBar = () => {
  const { t, i18n } = useTranslation();
  return (
    <div className="flex items-center pl-4 w-[117px] h-[40px] cursor-not-allowed staffListDownloadCheckbox text-primary border border-primary rounded-lg">
      <StaffListDownloadIcon />
      <div className="pl-2.5">{t('download')}</div>
    </div>
  );
};
export default DownloadBar;
